import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next'
import PdfViewerRoot from '../../src/views/prepFq/PdfViewer';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const PdfViewerPage = () => {
  const { t } = useTranslation(["prepFq"]);
  return (
    <React.Fragment>
      <Head>
        <title>{t(`prepFq:metaTitle.pdf`)}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <PdfViewerRoot />
    </React.Fragment>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['common', 'prepFq', 'footer', 'header']),
  }
});

export default PdfViewerPage;